import { Draggable } from 'react-beautiful-dnd';
import { IShopList } from '../ShopModal';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import iconDnd from '../../../../images/etc/icon_dnd.svg';
import React from 'react';
interface IDraggableCardProps {
    /**
     * @alias shop정보
     */
    shop: IShopList;

    /**
     * @alias 드래그앤드롭 index
     */
    index: number;

    /**
     * @alias shopStatus (상단고정별로 나누어진 상태)의 index
     */
    info: number;

    /**
     * @alias 날짜 변경 핸들러
     */
    handleDateChange: (id: number, date: Date | null, type: 'start' | 'end') => void;

    /**
     * @alias 날짜 유효성 검사 핸들러
     */
    handleDateBlur?: (id: number, date: string, type: 'start' | 'end') => void;

    /**
     * @alias 날짜 포커스 핸들러
     */
    handleDateFocus?: (id: number, date: string, type: 'start' | 'end') => void;
}
const NoFixedPeriod = styled.span`
    color: #aaaaaa;
`;
const DraggableItem = styled.div<{ isDragging: boolean }>`
    flex: 1;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    user-select: none;
    padding: 6px 20px;
    min-height: 44px;
    border-top: 1px solid #dfdfdf;
    background: ${(props) => (props.isDragging ? '#FFFFFF 0% 0% no-repeat padding-box' : '#FFFFFF')};
    box-shadow: ${(props) => (props.isDragging ? '0px 3px 6px #00000029' : 'none')};
    border-radius: ${(props) => (props.isDragging ? '4px' : 'none')};
`;
const IconContainer = styled.span`
    display: inline-block;
    width: 24px;
`;

const TextContainer = styled.span`
    flex: 1;
    text-align: center;
`;

const DatePickerContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 250px;
`;

function DraggableCard({ shop, index, info, handleDateChange, handleDateBlur, handleDateFocus }: IDraggableCardProps) {
    return (
        <Draggable key={shop.id} draggableId={shop.id + ''} index={index}>
            {(provided, snapshot) => (
                <DraggableItem
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    isDragging={snapshot.isDragging}
                >
                    <IconContainer>
                        <img src={iconDnd} style={{ verticalAlign: 'middle' }} />
                    </IconContainer>
                    <TextContainer>{shop.shopName}</TextContainer>
                    <TextContainer>{shop.cate}</TextContainer>
                    <DatePickerContainer>
                        {/* datepicker일 때 */}
                        {info !== 2 ? (
                            <div className="custom-datepicker">
                                {/** 시작날짜가 없다면 신규 등록하는 값이므로 디폴트값은 오늘 */}
                                <DatePicker
                                    selected={new Date(shop.exposureStartDate || new Date())}
                                    onChange={(date: Date | null, e: React.SyntheticEvent<any>) => {
                                        // e.type 이 blur 일 경우 text input 에서 직접 입력 하는 경우이기 때문에 호출 막음
                                        // 호출을 막지 않을 경우 blur 이벤트에서 별도 호출하는 handleDateChange가 있기때문에 중복 호출 됨 -> 느려짐
                                        if (e.type !== 'click') {
                                            return;
                                        }
                                        handleDateChange(shop.id, date, 'start');
                                    }}
                                    selectsStart
                                    startDate={new Date(shop.exposureStartDate || new Date())}
                                    endDate={
                                        new Date(shop.exposureEndDate || new Date().setMonth(new Date().getMonth() + 1))
                                    }
                                    dateFormat="yyyy-MM-dd"
                                    onBlur={(e) => {
                                        // e.type 이 click 일 경우 text input 에서 직접 입력 하는 경우이기 때문에 호출 막음
                                        // 호출을 막지 않을 경우 blur 이벤트에서 별도 호출하는 handleDateChange가 있기때문에 중복 호출 됨 -> 느려짐
                                        if (e.type !== 'blur') {
                                            return;
                                        }
                                        handleDateBlur && handleDateBlur(shop.id, e.target.value, 'start');
                                    }}
                                    onFocus={(e) =>
                                        handleDateFocus && handleDateFocus(shop.id, e.target.value, 'start')
                                    }
                                    minDate={new Date()}
                                />
                                &nbsp;&nbsp;~&nbsp;&nbsp;
                                {/** 종료날짜가 없다면 신규 등록하는 값이므로 디폴트값은 한달뒤 */}
                                <DatePicker
                                    selected={
                                        new Date(shop.exposureEndDate || new Date().setMonth(new Date().getMonth() + 1))
                                    }
                                    onChange={(date: Date | null, e: React.SyntheticEvent<any>) => {
                                        // e.type 이 blur 일 경우 text input 에서 직접 입력 하는 경우이기 때문에 호출 막음
                                        // 호출을 막지 않을 경우 blur 이벤트에서 별도 호출하는 handleDateChange가 있기때문에 중복 호출 됨 -> 느려짐
                                        if (e.type !== 'click') {
                                            return;
                                        }
                                        handleDateChange(shop.id, date, 'end');
                                    }}
                                    selectsEnd
                                    startDate={new Date(shop.exposureStartDate || new Date())}
                                    endDate={
                                        new Date(shop.exposureEndDate || new Date().setMonth(new Date().getMonth() + 1))
                                    }
                                    minDate={new Date()}
                                    dateFormat="yyyy-MM-dd"
                                    onBlur={(e) => {
                                        // e.type 이 click 일 경우 text input 에서 직접 입력 하는 경우이기 때문에 호출 막음
                                        // 호출을 막지 않을 경우 blur 이벤트에서 별도 호출하는 handleDateChange가 있기때문에 중복 호출 됨 -> 느려짐
                                        if (e.type !== 'blur') {
                                            return;
                                        }
                                        handleDateBlur && handleDateBlur(shop.id, e.target.value, 'end');
                                    }}
                                    onFocus={(e) => handleDateFocus && handleDateFocus(shop.id, e.target.value, 'end')}
                                />
                            </div>
                        ) : (
                            <NoFixedPeriod>고정기간 없음</NoFixedPeriod>
                        )}
                    </DatePickerContainer>
                </DraggableItem>
            )}
        </Draggable>
    );
}
export default React.memo(DraggableCard);
//props가 변하지않으면 렌더링 하지 않도록 React.memo로 감싸줌
